export default __webpack_public_path__ + "static/media/default.396202c46111e2011977b767aee3444a.png";